<template>
  <div>
    <div v-for="blockData in blocksData" :key="blockData?.id">
      <GenericBlock
        :component-type="blockData.__typename"
        :content="blockData"
      />
    </div>
  </div>
</template>

<script setup>
import { useStrapiPageSeo } from '~/composables/useStrapiPage'

const { locale } = useI18n()
const route = useRoute()
const slug = route.params.slug.toString()
const pageData = await useStrapiPage({
  slug: `${slug}_${locale.value}`,
  locale: convertLocaleIntoBCP47(locale.value),
})
const blocksData = computed(() => pageData?.data?.value?.pages?.[0]?.contents)
definePageMeta({
  layout: 'default-max-screen',
  preloaderType: 'strapi',
})

useStrapiPageSeo({
  pageData,
})
</script>
